import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3>Astravision</h3>
            <p>Complete school management software solution with mobile apps, payment gateway integration, and cloud-based infrastructure for modern educational institutions.</p>
          </div>

          <div className="footer-column">
            <h4>Product</h4>
            <ul className="footer-links">
              <li><a href="#features">Features</a></li>
              <li><a href="#solutions">Solutions</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#">Mobile Apps</a></li>
              <li><a href="#">API Access</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul className="footer-links">
              <li><a href="#">Help Center</a></li>
              <li><a href="#">Documentation</a></li>
              <li><a href="#">Video Tutorials</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#">Request Demo</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Contact</h4>
            <ul className="footer-links">
              <li>ASTRAVISION SOFTECH PRIVATE LIMITED</li>
              <li><a href="tel:+919741979100">+91 9741979100</a></li>
              <li>#16, Survey No.52/2, 11th Cross,<br />Balajinagar, Thigalarapalya Main Road,<br />Bangalore 560058</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          © 2026 Astravision. All rights reserved.
          &nbsp;|&nbsp;
          <a href="https://astravision.net/school-management/privacy-policy" style={{ color: 'inherit', textDecoration: 'underline' }}>Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
